import { authenticated } from '../../helpers/auth-header';
import insighttAPI from '../clients/insightt-api-client';
import { appEndpoints } from '../endpoints';

const getBranches = (fromCache = true) =>
  authenticated(insighttAPI, { fromCache }).get(appEndpoints.getBranchesAPI());

const getRoles = () => authenticated(insighttAPI).get(appEndpoints.getRolesAPI());

const getAlerts = () => authenticated(insighttAPI).get(appEndpoints.getAlertsAPI());

const toggleAlert = (payload) => authenticated(insighttAPI).post(appEndpoints.toggleAlertAPI(), payload);

const getServerTime = () => authenticated(insighttAPI).get(appEndpoints.getServerTimeAPI());

const setServerTime = (payload) => authenticated(insighttAPI).post(appEndpoints.setServerTimeAPI(), payload);

const getCompanySubscription = () => authenticated(insighttAPI).get(appEndpoints.getCompanySubscriptionAPI());

export const appService = {
  getBranches,
  getRoles,
  getAlerts,
  toggleAlert,
  getServerTime,
  setServerTime,
  getCompanySubscription: getCompanySubscription,
};
